import {z} from 'zod';
import paginatedSchema from "../common/paginatedSchema";
import {clubSchema} from "../club/clubSchema";
import {seasonSchema} from "../seasons/seasonsSchema";
import dayjs from "dayjs";

const raceStatusSchema = z.enum(["PLANNED", "IN_PROGRESS", "FINISHED"]);
const resultsStatusSchema = z.enum(["PUBLISHED", "UNPUBLISHED"]);
const publishStatusSchema = z.enum(["PUBLISHED", "UNPUBLISHED", "ANNOUNCED"]);

const rulesSchema = z.object({
    startNumbers: z.boolean(),
    totalLapsCountForOverallResults: z.number(),
    categoryLapsCount: z.record(z.number(), z.number()),
});

const raceShortSchema = z.object({
    id: z.number()
        .int()
        .positive(),
    name: z.string()
        .min(3, {message: "Název závodu musí mít alespoň 3 znaky."})
        .max(100, {message: "Maximální délka názvu závodu je 100 znaků."}),
    date: z.string()
        .refine(value => {
            return dayjs(value).isValid()
        }, {message: "Datum závodu musí být vyplněno ve formátu DD.MM.YYYY"}),});

const raceSchema = raceShortSchema.extend({
    time: z.string()
        .optional().nullable()
        .refine(value => {
            if (value === null || value === "" || value === undefined)
                return true;
            return dayjs(value, "HH:mm").isValid()
        }, {message: "Čas závodu musí být vyplněn ve formátu HH:MM"}),
    location: z.string()
        .max(100, {message: "Maximální délka názvu lokace je 100 znaků."}),
    description: z.string()
        .max(2000, {message: "Maximální délka popisu závodu je 2000 znaků."})
        .optional().nullable(),
    club: clubSchema
        .optional().nullable(),
    status: raceStatusSchema,
    resultStatus: resultsStatusSchema,
    publishStatus: publishStatusSchema,
    rules: rulesSchema,
    raceSeason: seasonSchema,
    organizersIds: z.array(z.number()),
    createdById: z.number(),
    updatedById: z.number(),
});

const raceDetailSchema = raceSchema.omit({
    status: true,
    resultStatus: true,
    rules: true,
    createdById: true,
    updatedById: true,
});

const paginatedShortRacesSchema = paginatedSchema(raceShortSchema);
const paginatedRacesSchema = paginatedSchema(raceSchema);

type Race = z.infer<typeof raceSchema>;
type RaceShort = z.infer<typeof raceShortSchema>;
type RaceDetail = z.infer<typeof raceDetailSchema>;
type PaginatedShortRaces = z.infer<typeof paginatedShortRacesSchema>;
type PaginatedRaces = z.infer<typeof paginatedRacesSchema>;
type RaceStatus = z.infer<typeof raceStatusSchema>;
type ResultsStatus = z.infer<typeof resultsStatusSchema>;
type PublishStatus = z.infer<typeof publishStatusSchema>;
type Rules = z.infer<typeof rulesSchema>;

export {
    raceShortSchema,
    raceSchema,
    raceDetailSchema,
    paginatedShortRacesSchema,
    type Race,
    type RaceShort,
    type RaceDetail,
    type PaginatedShortRaces,
    type PaginatedRaces,
    type RaceStatus,
    type ResultsStatus,
    type PublishStatus,
    type Rules
};